export const buildTag = BUILD_TAG
export default `Version: ${BUILD_TAG}`
